import { render, staticRenderFns } from "./SendSmsForm.vue?vue&type=template&id=050dbebd"
import script from "./SendSmsForm.vue?vue&type=script&lang=js"
export * from "./SendSmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports